import React, { useState, useRef, useEffect, useContext } from "react";
import Logo from "../assets/Icon/applogo.svg";
import { MyContext } from "../Context/MyProvider";
import { useTranslation } from "react-i18next";

const ShowToast = () => {
    const { t } = useTranslation();
    const { showToast, setShowToast, toastMsg, setToastMsg, lightLogo, BaseUrl } = useContext(MyContext);

    const [visible, setVisible] = useState(false);
    const [currentMsg, setCurrentMsg] = useState("");

    const classRef = useRef(null);
    const timerRef = useRef(null);

    const startHideTimer = () => {

        timerRef.current = setTimeout(() => {

            classRef.current?.classList.remove("open");

            setTimeout(() => {
                setVisible(false);
                setShowToast(false);
                setToastMsg("");
            }, 300);

        }, 3000);
    };

    useEffect(() => {
        if (!showToast || !toastMsg) return;

        if (!visible) {
            setCurrentMsg(toastMsg);
            setVisible(true);
            setTimeout(() => {
                classRef.current?.classList.add("open");
            }, 50);
            startHideTimer();
        }

        else if (toastMsg !== currentMsg) {
            clearTimeout(timerRef.current);
            classRef.current?.classList.remove("open");
            setTimeout(() => {
                setCurrentMsg(toastMsg);
                setTimeout(() => {
                    classRef.current?.classList.add('open');
                }, 50);
                startHideTimer();
            }, 300);
        }

        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
        };

    }, [showToast, toastMsg]);

    if (!visible) return null;

    return (
        <div ref={classRef} className="showtoast_page">
            <img src={lightLogo ? (BaseUrl + lightLogo) : Logo} className="w-[30px] rounded-full object-contain" alt="Logo" />
            <p className="text-gray-900 text-[15px] font-semibold w-full md:max-w-[500px]">
                {t(toastMsg)}
            </p>
        </div>
    );
};

export default ShowToast;